import React from 'react';
import Card from '../../../components/ui/Card';
import Badge from '../../../components/ui/Badge';

const VacancyHeatmap = ({ data }) => {
  const getVacancyColor = (rate) => {
    const numRate = parseFloat(rate);
    if (numRate >= 50) return 'bg-red-500';
    if (numRate >= 30) return 'bg-orange-500';
    if (numRate >= 15) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const getVacancyIntensity = (rate) => {
    const numRate = parseFloat(rate);
    if (numRate >= 50) return 'opacity-100';
    if (numRate >= 30) return 'opacity-75';
    if (numRate >= 15) return 'opacity-50';
    return 'opacity-25';
  };

  return (
    <Card className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground mb-2">Vacancy Heatmap</h2>
        <p className="text-sm text-muted-foreground">
          Visual representation of vacancy rates across centers and floors
        </p>
      </div>

      <div className="mb-6">
        <div className="flex items-center gap-4 text-sm">
          <span className="text-muted-foreground">Vacancy Rate:</span>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-green-500 opacity-25 rounded"></div>
            <span>0-15%</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-yellow-500 opacity-50 rounded"></div>
            <span>15-30%</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-orange-500 opacity-75 rounded"></div>
            <span>30-50%</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-red-500 opacity-100 rounded"></div>
            <span>50%+</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data?.map((item, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg border-2 ${
              getVacancyColor(item?.vacancyRate)
            } ${getVacancyIntensity(item?.vacancyRate)}`}
          >
            <div className="bg-white rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">{item?.centerId}</p>
                  <p className="text-lg font-bold text-foreground">{item?.floor}</p>
                </div>
                <Badge
                  variant={
                    parseFloat(item?.vacancyRate) >= 50
                      ? 'danger'
                      : parseFloat(item?.vacancyRate) >= 30
                      ? 'warning' :'success'
                  }
                >
                  {item?.vacancyRate}%
                </Badge>
              </div>
              <div className="grid grid-cols-3 gap-2 text-sm">
                <div>
                  <p className="text-muted-foreground">Total</p>
                  <p className="font-semibold text-foreground">{item?.total}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">Vacant</p>
                  <p className="font-semibold text-red-600">{item?.vacant}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">Occupied</p>
                  <p className="font-semibold text-green-600">{item?.occupied}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <h3 className="text-sm font-semibold text-foreground mb-2">Summary</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground">Total Locations</p>
            <p className="text-lg font-bold text-foreground">{data?.length}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Avg Vacancy Rate</p>
            <p className="text-lg font-bold text-foreground">
              {(data?.reduce((sum, item) => sum + parseFloat(item?.vacancyRate), 0) / data?.length)?.toFixed(2)}%
            </p>
          </div>
          <div>
            <p className="text-muted-foreground">Total Units</p>
            <p className="text-lg font-bold text-foreground">
              {data?.reduce((sum, item) => sum + item?.total, 0)}
            </p>
          </div>
          <div>
            <p className="text-muted-foreground">Total Vacant</p>
            <p className="text-lg font-bold text-red-600">
              {data?.reduce((sum, item) => sum + item?.vacant, 0)}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default VacancyHeatmap;